import React from "react";
import './SimpleCheckListComponent.scss';
import {ItemSimpleCheckList, SimpleCheckListComponentTypes} from "./SimpleCheckListComponent.types";
import checkIcon from "../../../assets/namespace/icons/checkIcon";
import {Space} from "antd";

/*
* This component render a list of text with independent icons itself
* */
const SimpleCheckListComponent = ({className, ArrayItemsSimpleCheck}: SimpleCheckListComponentTypes) => {

  const bulletList: any = {
    check: checkIcon({color:'#FF4E04'})
  }

  function getBullet(bulletType:string):any{
    return bulletList[bulletType]
  }

  return(
    <div className={`SimpleCheckList ${className}`}>
      {
        ArrayItemsSimpleCheck.map((item:ItemSimpleCheckList) => (
          <div key={item.id}>
            <Space className={'SimpleCheckListItem'} >
              {
                getBullet(item.type)
              } {item.text}
            </Space>
          </div>
        ))
      }
    </div>
  )
}

export default SimpleCheckListComponent;
